import { createSlice } from '@reduxjs/toolkit'
import CommonServices from '../../services/commonServices';

const initialState = {
  regions: []
};

const regionsSlice = createSlice({
  name: 'regions',
  initialState,
  reducers: {
    regionsLoaded(state, action) {
      state.regions = action.payload;
    }
  },
})

export const { regionsLoaded } = regionsSlice.actions;

export default regionsSlice.reducer;

export const fetchRegionsList = () => async (dispatch) => { 
  try {
    const respData = await CommonServices.getRegions();
    if (respData.success) {
      const regionsList = respData.responseObject.value.regions;    

      if(regionsList){
        const objectsArray = regionsList.map((item) => ({ value: item.id, label: item.description }));
        dispatch(regionsLoaded(objectsArray));
      }
    }
  } catch (error) {
    console.error('Failed to fetch:', error.message);
  }
};

